import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/home';
import About from './pages/about-us'
import Contact from "./pages/contact-us";
import Doctors from "./pages/doctors";
import Gallery from "./pages/gallery";
import Services from "./pages/services";




// services card import
import Medicine from "./pages/medicine";
import Orthopedic from "./pages/orthopedic";
import Generelsurgery from "./pages/general-surgery";
import Gastrology from "./pages/gastrology";
import Ent from "./pages/ent";
import CriticalCare from "./pages/critical-care";
import TraumaCare from "./pages/trauma-care";
import JointReplacement from "./pages/joint-replacement";


import ScrollToTop from "./components/scrolltop";


import Topbar from './components/topbar';
import Header from './components/header';
import Footer from './components/footer';
import Top from "./components/top";
// import ScrollTop from "./components/scrolltop";

const Layout = ({ children }) => (
  <>
    <Topbar />
    <Header />
    <main>{children}</main>
    <Footer />
    <Top />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />


      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about-us" element={<Layout><About /></Layout>} />
        <Route path="/contact-us" element={<Layout><Contact /></Layout>} />
        <Route path="/our-doctors" element={<Layout><Doctors /></Layout>} />
        <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
        <Route path="/services" element={<Layout><Services /></Layout>} />
        <Route path="/services/medicine" element={<Layout><Medicine /></Layout>} />
        <Route path="/services/orthopedic" element={<Layout><Orthopedic /></Layout>} />
        <Route path="/services/general-surgery" element={<Layout><Generelsurgery /></Layout>} />
        <Route path="/services/gastrology" element={<Layout><Gastrology /></Layout>} />
        <Route path="/services/ent" element={<Layout><Ent /></Layout>} />
        <Route path="/services/critical-care" element={<Layout><CriticalCare /></Layout>} />
        <Route path="/services/trauma-care" element={<Layout><TraumaCare /></Layout>} />
        <Route path="/services/joint-replacement" element={<Layout><JointReplacement /></Layout>} />
      </Routes>
    </Router>
  );
}

export default App;
